import React from 'react';
import ReportBox from "./ReportBox";

const ReportBatchHistory = () => {
    return (
        <div>
            <ReportBox pageName="batchHistory" apiAddress="Batch/Report" title="گزارش بچ"/>
        </div>
    );
};

export default ReportBatchHistory;